// extracted by mini-css-extract-plugin
export default {"container":"RelevanceSlider_container__DA9EH","icon":"RelevanceSlider_icon__l4qfr","slider":"RelevanceSlider_slider__ErZdg"};